import { SVGProps, memo } from 'react'
import CommonTopArtSvg from 'src/components/icons/CommonTopArt.svg'

const CommonTopArt = memo<SVGProps<SVGSVGElement>>(props => <CommonTopArtSvg {...props} />)

export default CommonTopArt
